import { render } from "./BoletoPayment.vue?vue&type=template&id=fd160af2&ts=true"
import script from "./BoletoPayment.vue?vue&type=script&lang=ts"
export * from "./BoletoPayment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__